export enum SearchQueryVisibilityEnum {
    GENERAL = 'General',
    PERSONAL = 'Personal'
}
